import { IManhattanBundle, IBundleProduct, IProductLine } from "./types";
import BundleProductFactory from "../../../factories/manhattan/bundle/BundleProductFactory";

export default class Bundle implements IManhattanBundle {

  id: number;
  identifier: string;
  name: string;
  productLine: IProductLine;
  status: number;
  bundleProducts: IBundleProduct[];

  constructor(
    id: number,
    identifier: string,
    name: string,
    productLine: IProductLine,
    status: number,
    bundleProducts: IBundleProduct[]
  ) {
    this.id = id;
    this.identifier = identifier;
    this.name = name;
    this.productLine = productLine;
    this.status = status;
    this.bundleProducts = [];
    bundleProducts.forEach((bundleProduct: IBundleProduct) => {
      this.bundleProducts.push(BundleProductFactory.create(bundleProduct));
    });
  }

}
